import { ItinResourceProps } from "../types";

export const StopResource: ItinResourceProps = {
  name: "stops",
  recordRepresentation: (r) => r.name,
};

export * from "./StopList";
